import { render, staticRenderFns } from "./ModalPermissionGroup.vue?vue&type=template&id=791906f8&scoped=true"
import script from "./ModalPermissionGroup.vue?vue&type=script&lang=js"
export * from "./ModalPermissionGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalPermissionGroup.vue?vue&type=style&index=0&id=791906f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791906f8",
  null
  
)

export default component.exports